const state= {
  template: {},
  checklist_teamplates: {
    data: [],
    total: 0,
    pages: {
      limit: 100,
      page: 1,
      totalPage : 1,
      filter: {
        id : null,
        name : null
      }
    },
  },
  templateLoading: {
    listing: false
  },
};

const getters = {
  checklistTeamplates : (state) => state.checklist_teamplates,
  templateLoading: (state) => state.templateLoading,
  templateItem: (state) => state.template,
};

const actions = {
  async setItemTemplate({commit}, params){
    commit('setTemplate', params)
  },
  async getListCheckListTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      commit( 'setTemplateLoading', true )
      global.axios(`api/checklist-templates`, {
        method: "GET",
        params: params,
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        response.data.data.pages = params
        commit( 'setTemplateLoading', false );
        commit( 'setListCheckListTemplate', response.data.data );
        resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async searchTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      commit( 'setTemplateLoading', true )
      global.axios(`api/checklist-templates`, {
        method: "GET",
        params: {
          limit: params[0] || 50,
          page: params[1] || 1,
          filter: params[2] || ''
        },
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        commit( 'setTemplateLoading', false )
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async getItemTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-templates/${params}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        if(response.data.status == 200) {
          commit('setTemplate', response.data.data)
        }
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async getCheckListTemplateEntries({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-group/template-list/${params}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async createTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-templates`, {
        method: "POST",
        data: params,
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        if(response.data.status == 200) {
          commit('updateListCheckListTemplate', response.data.data)
        }
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async updateTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-templates/${params.id}`, {
        method: "PUT",
        data: params,
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        if(response.data.status == 200) {
          if(params.hasOwnProperty('index')) {
            response.data.data.index = params.index
          }
          commit('updateItemTemplate', response.data.data)
        }
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async updateChecklistTemplateGroup({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-group/${params.id}`, {
        method: "PUT",
        data: params,
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async createChecklistTemplateGroup({commit}, params){
    return new Promise (( resolve, reject ) => {
		global.axios(`api/checklist-group`, {
		  method: "POST",
		  data: params,
		  headers: {
			Accept: "application/json",
		  }
		})
		.then(response => {
		   resolve( response )
		})
		.catch(error => reject( error ));
	});
  },
  async updateChecklistTemplateEntries({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-template-entries/${params.id}`, {
        method: "PUT",
        data: params,
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async createChecklistTemplateEntries({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-template-entries`, {
        method: "POST",
        data: params,
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
		resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async deleteTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      commit( 'setTemplateLoading', true )
      global.axios(`api/checklist-templates`, {
        method: "DELETE",
        params: {
          ids: params
        },
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        commit( 'setTemplateLoading', false )
        commit( 'deleteTemplate', params)
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async deleteChecklistTemplateGroup({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-group/${params.id}`, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async deleteChecklistTemplateEntries({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-template-entries`, {
        method: "DELETE",
		params: {
			ids: params
		},
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async uploadFileChecklistTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
        commit( 'setTemplateLoading', true )
        let formData = new FormData();
        formData.append('file_import',params.fileChecklistTemplate);
        formData.append('contract_id',params.contract_id);
        global.axios.post(`api/checklist-templates/import`,formData,
        {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
          commit( 'setTemplateLoading', false )
          resolve( response );
        })
        .catch(error => reject( error ));
    });
  },
  async getMasterChecklist(){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-templates`, {
        method: "GET",
        params: {
          filter:{
            is_master:true
          },
          limit:25,
          page:-1,
        },
        headers: {
          Accept: "application/json",
        }
      })
          .then(response => {
            resolve( response );
          })
          .catch(error => reject( error ));
    });
  },
  async cloneTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-templates/clone-master`, {
        method: "POST",
        data: params,
        headers: {
          Accept: "application/json",
        }
      })
          .then(response => {
            resolve( response )
          })
          .catch(error => reject( error ));
    });
  },
};

const mutations = {
  setListCheckListTemplate (state, data) {
    data.pages.totalPage = Math.ceil(data.total / data.pages.limit );
    state.checklist_teamplates.data = data.items
    state.checklist_teamplates.total = data.total
    state.checklist_teamplates.pages = data.pages
  },
  setTemplateLoading (state, val) {
    state.templateLoading.listing = val
  },
  setTemplate (state, data) {
    state.template = data
  },
  updateItemTemplate (state, data) {
      state.checklist_teamplates.data =  state.checklist_teamplates.data.map(item => item.id === data.id ? data : item)
  },
  updateListCheckListTemplate (state, data){
    state.checklist_teamplates.data.push(data)
    state.checklist_teamplates.total += 1
    state.checklist_teamplates.pages.totalPage = Math.ceil(state.checklist_teamplates.total / state.checklist_teamplates.pages.limit );
  },
  deleteTemplate (state, listID) {
    state.checklist_teamplates.data =  state.checklist_teamplates.data.filter(function(obj) {
      return !listID.some(function(obj2) {
            return obj.id == obj2;
      });
    });
    state.checklist_teamplates.total = state.checklist_teamplates.total - listID.length ;
    state.checklist_teamplates.pages.totalPage = Math.ceil(state.checklist_teamplates.total / state.checklist_teamplates.pages.limit );
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
